export const FREE_CALL_TEXT_ID = "FreeCallTextId";
export const HELP_LINE_ID = "HelpLineId";
export const COUNTRY_ID = "CountryId";
export const HELP_LINE_BOX_ID = "HelpLineBoxId";
